module.exports = __webpack_public_path__ + "img/myob-exo.722ee9f6.jpg";